export default __webpack_public_path__ + "static/media/pen-solid.2808f564.svg";